import { useTranslation } from 'react-i18next';
import { ColumnDef } from '@tanstack/react-table';
import { Button } from '@/components/ui/button';
import { AppReleaseItemResponseDto } from '../types/releases-dto';
import ReleaseStatus from '../components/ReleaseStatus';
import { DateTimeHelper } from '@/utils/dateTimeHelper';

const useReleasesListColumns = (): ColumnDef<AppReleaseItemResponseDto>[] => {
    const { t } = useTranslation();

    return [
        {
            accessorKey: 'version',
            header: ({ column }) => {
                return (
                    <Button
                        variant="link"
                        className={
                            'h-fit p-0 flex items-center gap-2.5 text-sm text-popover-1000 font-medium no-underline hover:no-underline'
                        }
                        onClick={() => null}
                    >
                        {t('main.releases.table.header.version')}
                        <div
                            className={`transition-transform duration-50 ease-in-out ${
                                column.getIsSorted() === 'asc' ? '-rotate-180' : 'rotate-0'
                            }`}
                        ></div>
                    </Button>
                );
            },
            cell: ({ row }) => (
                <div className={'flex items-center gap-2.5'}>
                    <h4 className="text-sm text-popover-800 truncate">{row.getValue('version')}</h4>
                </div>
            ),
        },
        {
            accessorKey: 'releasedAt',
            header: ({ column }) => {
                return (
                    <Button
                        variant="link"
                        className={
                            'h-fit p-0 flex items-center gap-2.5 text-sm text-popover-1000 font-medium no-underline hover:no-underline'
                        }
                        onClick={() => null}
                    >
                        {t('main.releases.table.header.releasedAt')}
                        <div
                            className={`transition-transform duration-50 ease-in-out ${
                                column.getIsSorted() === 'asc' ? '-rotate-180' : 'rotate-0'
                            }`}
                        ></div>
                    </Button>
                );
            },
            cell: ({ row }) => (
                <div className={'flex items-center gap-2.5'}>
                    <h4 className="text-sm text-popover-800 truncate">
                        {DateTimeHelper.formatDate(row.getValue('releasedAt'), 2)}
                    </h4>
                </div>
            ),
        },
        {
            accessorKey: 'isActive',
            header: ({ column }) => {
                return (
                    <Button
                        variant="link"
                        className={
                            'h-fit p-0 flex items-center gap-2.5 text-sm text-popover-1000 font-medium no-underline hover:no-underline'
                        }
                        onClick={() => null}
                    >
                        {t('main.releases.table.header.status')}
                        <div
                            className={`transition-transform duration-50 ease-in-out ${
                                column.getIsSorted() === 'asc' ? '-rotate-180' : 'rotate-0'
                            }`}
                        ></div>
                    </Button>
                );
            },
            cell: ({ row }) => (
                <div className={'flex items-center gap-2.5'}>
                    <h4 className="text-sm text-popover-800 truncate">
                        {<ReleaseStatus status={row.getValue('isActive')} />}
                    </h4>
                </div>
            ),
        },
    ];
};

export default useReleasesListColumns;
